export default __webpack_public_path__ + "static/media/whychooseicon5.d24550d0.png";